import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { UmcInstancesService } from '@go-modules/services/umc-instances/umc-instances.service';

export const umcInstancesServiceModule = angular
	.module('umcInstancesServiceModule', [])
	.factory('umcInstancesService', downgradeInjectable(UmcInstancesService) as any)
	.name;
